class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (!this.dataset.url) {
        console.error('Error: No URL provided for product recommendations');
        return;
      }
      fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          const splideList = this.querySelector('.splide__list');
          const sectionWrapper = this.closest('.spaced-section');
          if (splideList && splideList.children.length === 0 && sectionWrapper) {
            sectionWrapper.style.display = 'none';
            return; // prevent rendering empty block
          }

          const reviewStars = document.querySelectorAll(".review-box .jdgm-prev-badge__stars");
          const reviewCountText = document.querySelectorAll(".review-box .jdgm-prev-badge__text");
          for(let z = 0; z < reviewStars.length; z++){
            const ratingCount = Math.round(reviewStars[z].getAttribute('data-score') * 10) / 10;
            reviewStars[z].innerHTML = `<svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 0L6.73483 3.80041H10.7308L7.49799 6.14919L8.73282 9.94959L5.5 7.60081L2.26718 9.94959L3.50201 6.14919L0.269189 3.80041H4.26517L5.5 0Z" fill="#F4C32B"/></svg>${ratingCount}`;
            const reviewCountList = reviewCountText[z].textContent;
            const reviewsTextRemove = reviewCountList.replace('reviews','');
            reviewCountText[z].innerHTML = reviewsTextRemove;
          }
        }
        if (typeof productCardVariantSelects === 'function') {
          productCardVariantSelects();
        }
      })
      .catch(e => {
        console.error('Error loading product recommendations:', e);
      });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);